import React from "react";
import ReactTooltip from "react-tooltip";

const UrlToolTip = ({
  copied,
  onCopyUrlClick,
  copyUrlToolTipPlacement,
  copyUrlToolTip,
}) => {
  return (
    <>
      {/* a tag is used for ReactToolTip see notes for use */}
      <div
        className="share-item"
        onClick={onCopyUrlClick}
        data-tip
        data-for="copyUrl"
      >
        <i
          className={"fas text-white " + (copied ? "fa-check" : "fa-link")}
        ></i>
      </div>
      {/* ReactTooltip is used to control the tool tip options and say what the tool tip should say */}
      <ReactTooltip
        id="copyUrl"
        type="dark"
        place={copyUrlToolTipPlacement}
        effect="solid"
      >
        <span>{copyUrlToolTip}</span>
      </ReactTooltip>
    </>
  );
};
export default UrlToolTip;
